import React, { useState, useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { Link45deg } from 'react-bootstrap-icons';

import FURGAPI from '../../services/api.furg'
import { decodeHexHtmlCharCodes } from '../../services/utils'
import { Alert } from '../../components/Alert'
import { Loading } from '../../components/Loading'

import $ from 'jquery'
import 'jquery-mask-plugin/dist/jquery.mask.min'
import './style.css';

const scrollToRef = ref => window.scrollTo(0, ref.current.offsetTop)

export default function Fips() {
    const estados = ['RS', 'AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'SC', 'SE', 'SP', 'TO']

    const { cd_vestibular } = useParams()

    const [dsProcessoSeletivo, setDsProcessoSeletivo] = useState()
    const [enemInfo, setEnemInfo] = useState('')
    const [periodosAceitos, setPeriodosAceitos] = useState([])
    const [cursos, setCursos] = useState([])
    const [modalidades, setModalidades] = useState(['AC'])
    const [nrInscricao, setNrInscricao] = useState()
    const [checkedSocialName, setCheckedSocialName] = useState('N')
    const [publicSchool, setPublicSchool] = useState(true)

    const [validYears, setValidYears] = useState([])
    const [enemInscriptionError, setEnemInscriptionError] = useState(false)

    const { register, handleSubmit, errors } = useForm()
    const formularioRef = useRef(null)

    const [error, setError] = useState('')
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        setLoading(true)
        FURGAPI.call('scv/Publico/infoProcesso', {
            cd_vestibular,
        })
            .then(resultado => {
                if (!resultado.cursos.length) {
                    setError('Processo seletivo não encontrado!')
                } else {
                    setDsProcessoSeletivo(resultado.ds_processo_seletivo)
                    setCursos(resultado.cursos)
                    setEnemInfo(resultado.infoEnem)
                    if (resultado.periodos_aceitos) {
                        setPeriodosAceitos(resultado.periodos_aceitos.split(','))
                    }
                    $('#dt_nascimento').mask('00/00/0000')
                    $('#nr_cpf').mask('000.000.000-00', { reverse: true })
                    $('#cep').mask('00000-000', { reverse: true })
                    $('#enem').mask('000000000000')
                    $('#nr_telefone').mask('(999) 9999-9999')
                    $('#nr_celular').mask('(999) A9999-9999', {
                        translation: {
                            'A': {
                                pattern: /\d/,
                                optional: true,
                            },
                        },
                    })
                }
                setLoading(false)
            })
            .catch(error => {
                setError(decodeHexHtmlCharCodes(error))
                setLoading(false)
            })
    }, [cd_vestibular])

    useEffect(() => {
        setPublicSchool(modalidades.includes('EP'))
    }, [modalidades])

    useEffect(() => {
        let arrayYears = [];
        if (periodosAceitos.length > 0) {
            for (let i = 0; i < periodosAceitos.length; i++) {
                arrayYears.push(parseInt(periodosAceitos[i].slice(-2)));
            }
        }
        setValidYears(arrayYears);
    }, [periodosAceitos])

    const handleChangeModalities = (modalidade, action) => {
        let newModalidades = [...modalidades]

        if (action) {
            if (modalidade === 'EP') {
                newModalidades.push('LI_EP');
            }
            newModalidades.push(modalidade)
        } else if (modalidade === 'EP') {
            newModalidades = ['AC']
            if (modalidades.includes('_PCD')) {
                newModalidades.push('_PCD')
            }
        } else {
            newModalidades = newModalidades.filter(item => item !== modalidade)
        }
        setModalidades(newModalidades)
    }

    const handleVerifyEnemNumber = (number) => {
        if (number.length === 12) {
            let year = parseInt(number.slice(0, 2));
            setEnemInscriptionError(!validYears.includes(year));
        }
    }

    const handleChangePossuiNomeSocial = (value) => {
        setCheckedSocialName(value)
    }

    const validateName = (value) => {
        if (typeof value === 'string' && /[.*+?^${}()|[\]@\\]/.test(value)) {
            return "O nome não deve conter caracteres especiais";
        }
        if (typeof value === 'string' && /\d/.test(value)) {
            return "O nome não deve conter números"
        }
        if (typeof value === 'string') {
            const partesNome = value.trim().split(/\s+/);
            if (partesNome.length < 2) {
                return "O nome deve conter pelo menos nome e sobrenome";
            }
        }
    };

    const handleOnSubmit = (data) => {
        data.modalidades_possiveis = obtemModalidadesPossiveis();
        data.periodos_aceitos = periodosAceitos.join(', ');

        setLoading(true)
        FURGAPI.call('scv/Publico/inscricao', { cd_vestibular, ...data })
            .then(resultado => {
                setLoading(false)
                setError('')
                if (resultado.nr_inscricao) {
                    setNrInscricao(resultado.nr_inscricao)
                } else {
                    let msgErro = 'Verifique as informações dos campos:'
                    for (const campo in resultado) {
                        msgErro += `<br/>${resultado[campo]}`
                    }
                    setError(<span dangerouslySetInnerHTML={{ __html: decodeHexHtmlCharCodes(msgErro) }}></span>)
                }
            })
            .catch(error => {
                setError(decodeHexHtmlCharCodes(error))
                setLoading(false)
            })
        scrollToRef(formularioRef)
    }

    const montaComponenteModalidades = (description, modality) => {
        let url = ''
        switch (modality) {
            case 'AC':
                url = 'https://sisu.furg.br/7-institucional/institucional/94-ampla-concorrencia';
                break;

            case 'V-PROAAF':
                url = 'https://sisu.furg.br/2016-04-26-18-00-54/2016-04-26-18-11-03/7-institucional/institucional/99-a1';
                break;

            case 'LI_EP':
                url = 'https://sisu.furg.br/matricula-e-documentacao/modalidades-de-ingresso/independente-de-renda-escola-publica-li-ep';
                break;

            case 'LI_PCD':
                url = 'https://sisu.furg.br/7-institucional/institucional/208-l13-candidatos-com-deficiencia-que-independentemente-da-renda-art-14-ii-portaria-normativa-n-18-2012-tenham-cursado-integralmente-o-ensino-medio-em-escolas-publicas-lei-n-12-711-2012';
                break;

            case 'LI_Q':
                url = 'https://sisu.furg.br/7-institucional/institucional/207-l14-candidatos-com-deficiencia-autodeclarados-pretos-pardos-ou-indigenas-que-independentemente-da-renda-art-14-ii-portaria-normativa-n-18-2012-tenham-cursado-integralmente-o-ensino-medio-em-escolas-publicas-lei-n-12-711-2012';
                break;

            case 'LI_PPI':
                url = 'https://sisu.furg.br/matricula-e-documentacao/modalidades-de-ingresso/independente-de-renda-escola-publica-preto-pardou-ou-indigena-li-ppi';
                break;

            case 'LB_EP':
                url = 'https://sisu.furg.br/matricula-e-documentacao/modalidades-de-ingresso/baixa-renda-escola-publica-lb-ep';
                break;

            case 'LB_PCD':
                url = 'https://sisu.furg.br/7-institucional/institucional/210-l9-candidatos-com-deficiencia-que-tenham-renda-familiar-bruta-per-capita-igual-ou-inferior-a-1-5-salario-minimo-e-que-tenham-cursado-integralmente-o-ensino-medio-em-escolas-publicas-lei-n-12-711-2012';
                break;

            case 'LB_Q':
                url = 'https://sisu.furg.br/7-institucional/institucional/209-l10-candidatos-com-deficiencia-autodeclarados-pretos-pardos-ou-indigenas-que-tenham-renda-familiar-bruta-percapita-igual-ou-inferior-a-1-5-salario-minimo-e-que-tenham-cursado-integralmente-o-ensino-medio-em-escolas-publicas-lei-n-12-711-2012';
                break;

            case 'LB_PPI':
                url = 'https://sisu.furg.br/matricula-e-documentacao/modalidades-de-ingresso/baixa-renda-escola-publica-preto-pardo-ou-indigena-lb-ppi';
                break;

            default:
                url = 'https://sisu.furg.br/matricula-e-documentacao/modalidades-de-ingresso';
                break;
        }



        return (
            <li className="d-flex justify-content-between text-secondary text-sd mt-1 list-group-item-custom ">{description}
                <a href={url} target="_blank" rel="noopener noreferrer">
                    <Link45deg size={22} color="var(--global-cor-info)" />
                </a>
            </li>
        )
    }

    const montaMsgErroObrigatorio = (nomeCampo, label) => {
        return (
            errors[nomeCampo] && (
                <div className="invalid-feedback d-block font-weight-bold">
                    {errors[nomeCampo]?.message}
                </div>
            )
        )
    }

    const montaMsgAtencao = (action, msg, cience, id) => {
        return (
            <div className="alert alert-warning mt-2" role="alert">
                <strong>{action}:</strong><p className="texto-formatado">{msg}</p>
                {cience && (
                    <section className="form-checkbox required mt-2">
                        <div className="form-check">
                            <input type="checkbox" id={id} name={id} value="1" ref={register({ required: 'Preenchimento obrigatório' })} />
                            <label htmlFor={id}>
                                Declaro que estou ciente das informações acima.
                            </label>
                        </div>
                        {montaMsgErroObrigatorio(id, 'Declaro que estou ciente')}
                    </section>
                )}
            </div>
        )
    }

    const obtemModalidadesPossiveis = () => {
        let modalidadesPossiveis = [...modalidades];

        if (modalidadesPossiveis.includes('LI_EP')) {
            for (let i = 0; i < modalidadesPossiveis.length; i++) {
                if (modalidadesPossiveis[i].includes('_') && modalidadesPossiveis[i] !== 'LI_EP' && modalidadesPossiveis[i] !== 'LB_EP') {
                    modalidadesPossiveis[i] = modalidadesPossiveis[i].replace('_', 'LI_');
                }
            }
        }
        let arrayTemp = []
        if (modalidadesPossiveis.includes('LB_EP')) {
            for (let i = 0; i < modalidadesPossiveis.length; i++) {
                if (modalidadesPossiveis[i].includes('LI_') && modalidadesPossiveis[i] !== 'LI_EP' && modalidadesPossiveis[i] !== 'LB_EP') {
                    arrayTemp.push(modalidadesPossiveis[i].replace('LI_', 'LB_'));
                }
            }
        }

        if (modalidadesPossiveis.includes('LI_PCD')) {
            modalidadesPossiveis.push('PROAAF');
        }

        modalidadesPossiveis = modalidadesPossiveis.filter(item => item !== 'EP');

        return [...modalidadesPossiveis, ...arrayTemp]
    }

    return (
        <div className="content">
            <div className="f-header-content f-header-content--centralizado">
                <h1 className="f-header-content_title"> Solicitação de matrícula on-line </h1>
                {!!cursos.length && <h2 className="f-header-content__descricao">Formulário de Inscrição - {dsProcessoSeletivo}</h2>}
            </div>
            <div className="container-sm card-body text-8vw">
                {loading && <Loading />}
                {error && <Alert variant="danger">{error}</Alert>}
                {!!cursos.length && (
                    <form onSubmit={handleSubmit(handleOnSubmit)} ref={formularioRef}>
                        {nrInscricao && (
                            <Alert>
                                <em>
                                    <strong>Inscrição realizada com sucesso!</strong>
                                </em>
                                <br />
                                <br />
                                <p>
                                    Seu número de inscrição é <strong style={{ color: 'red' }}>{nrInscricao}</strong>.
                                </p>
                            </Alert>
                        )}
                        <div className="card card-body w-100">
                            <fieldset >
                                <legend>Dados pessoais</legend>
                                <hr className="hr" />
                                <div className="form-label-group required">
                                    <label htmlFor="nome">Nome completo conforme identidade</label>
                                    <input type="text" id="nome" placeholder='Ex: Frederico Cavalcante Silva' name="nome" className="form-control" ref={register({ required: 'Preenchimento obrigatório', validate: validateName })} disabled={!!nrInscricao} />
                                    {montaMsgErroObrigatorio('nome', 'Nome')}
                                </div>

                                <section className="form-radio required">
                                    <label htmlFor='social_name_value'>Possui nome social registrado?</label>
                                    <div className="d-flex flex-row">
                                        <div className="form-check">
                                            <input onClick={(e) => { handleChangePossuiNomeSocial(e.target.value) }} type="radio" id="social_name_s" name="social_name_value" value="S" ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao} />
                                            <label htmlFor="social_name_s">Sim</label>
                                        </div>
                                        <div className="form-check">
                                            <input onClick={(e) => { handleChangePossuiNomeSocial(e.target.value) }} defaultChecked type="radio" id="social_name_n" name="social_name_value" value="N" ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao} />
                                            <label htmlFor="social_name_n">Não</label>
                                        </div>

                                    </div>
                                    {checkedSocialName === 'S' &&
                                        <>
                                            <div className="form-label-group required">
                                                <label htmlFor="nome_social">Nome social conforme carteira de nome social</label>
                                                <input type="text" id="nome_social" name="nome_social" className="form-control" ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao} />
                                            </div>
                                            {montaMsgErroObrigatorio('nome_social', 'Nome Social')}
                                        </>
                                    }
                                </section>

                                <div className="form-label-group required">
                                    <label htmlFor="dt_nascimento">Data de nascimento</label>
                                    <input
                                        type="text"
                                        placeholder='Ex: 01/01/2000'
                                        id="dt_nascimento"
                                        name="dt_nascimento"
                                        className="form-control"
                                        ref={register({ required: 'Preenchimento obrigatório' })}
                                        disabled={!!nrInscricao}
                                    />
                                    {montaMsgErroObrigatorio('dt_nascimento', 'Data de nascimento')}
                                </div>

                                <div className="form-label-group" >
                                    <label htmlFor="nr_telefone">Telefone residencial</label>
                                    <input type="text" id="nr_telefone" name="nr_telefone" className="form-control" placeholder="Exemplo: (00) 0000-0000" disabled={!!nrInscricao} />
                                </div>
                                <div className="form-label-group required">
                                    <label htmlFor="nr_celular">Telefone celular</label>
                                    <input type="text" id="nr_celular" name="nr_celular" className="form-control" placeholder="Exemplo: (00) 00000-0000" ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao} />
                                    {montaMsgErroObrigatorio('nr_celular', 'Telefone celular')}
                                </div>
                            </fieldset>
                        </div>

                        <div className="card card-body w-100">
                            <fieldset>
                                <legend>Documentos</legend>
                                <hr className="hr" />
                                <div className="form-label-group required">
                                    <label htmlFor="nr_cpf">CPF</label>
                                    <input type="text" id="nr_cpf" name="nr_cpf" className="form-control" ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao} />
                                    {montaMsgErroObrigatorio('nr_cpf', 'CPF')}
                                </div>

                            </fieldset>
                        </div>

                        <div className="card card-body w-100">

                            <fieldset>
                                <legend>Endereço para correspondência</legend>
                                <hr className="hr" />
                                <div className="form-label-group required">
                                    <label htmlFor="email">E-mail</label>
                                    <input type="text" id="email" name="email"
                                        placeholder='Exemplo: meu.melhor.email@site.com'
                                        className="form-control" ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao} />
                                    <small className="form-text text-muted">
                                        <strong>Cuidado:</strong> Observar se o e-mail está idêntico ao utilizado em seu serviço de e-mail.
                                    </small>
                                    {montaMsgErroObrigatorio('email', 'Endereço eletrônico')}
                                </div>
                                <div className="form-label-group required">
                                    <label htmlFor="endereco">Endereço residencial</label>
                                    <input type="text" id="endereco" name="endereco" className="form-control" ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao} />
                                    {montaMsgErroObrigatorio('endereco', 'Endereço residencial')}
                                </div>
                                <div className="form-label-group required">
                                    <label htmlFor="bairro">Bairro</label>
                                    <input type="text" id="bairro" name="bairro" className="form-control" ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao} />
                                    {montaMsgErroObrigatorio('bairro', 'Bairro')}
                                </div>
                                <div className="form-label-group required">
                                    <label htmlFor="cidade">Cidade</label>
                                    <input type="text" id="cidade" name="cidade" className="form-control" ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao} />
                                    {montaMsgErroObrigatorio('cidade', 'Cidade')}
                                </div>
                                <div className="form-label-group form-select required">
                                    <label htmlFor="uf_endereco">Estado</label>
                                    <select size="1" id="uf_endereco" name="uf_endereco" className="form-control" ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao}>
                                        <option value="">Selecione um estado</option>
                                        {estados.map(estado => (
                                            <option key={`uf_endereco_${estado}`} value={estado}>
                                                {estado}
                                            </option>
                                        ))}
                                    </select>
                                    {montaMsgErroObrigatorio('uf_endereco', 'Estado')}
                                </div>
                                <div className="form-label-group required">
                                    <label htmlFor="cep">CEP</label>
                                    <input type="text" id="cep" name="cep" className="form-control" placeholder="Exemplo: 96000-000" ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao} />
                                    {montaMsgErroObrigatorio('cep', 'CEP')}
                                </div>
                            </fieldset>
                        </div>

                        <div className="card card-body w-100">

                            <fieldset>
                                <legend>Questionário Socioeconômico</legend>
                                <hr className="hr" />

                                <section className="form-radio required">
                                    <label>Estudou integralmente o Ensino Médio em escola pública? (três anos do ensino médio)</label>
                                    <div className="d-flex flex-row">
                                        <div className="form-check">
                                            <input onChange={() => handleChangeModalities('EP', true)} type="radio" id="public_school_0" name="EP" value={1} ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao} />
                                            <label htmlFor="public_school_0">Sim</label>
                                        </div>
                                        <div className="form-check">
                                            <input onChange={() => handleChangeModalities('EP', false)} defaultChecked type="radio" id="public_school_1" name="EP" value={0} ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao} />
                                            <label htmlFor="public_school_1">Não</label>
                                        </div>
                                        {montaMsgErroObrigatorio('EP', 'Pessoa que estudou somente em escola pública')}
                                    </div>
                                </section>
                                {publicSchool &&
                                    <section className="form-radio required">
                                        <label>Deseja participar da modalidade de ingresso, considerando sua renda per capita igual ou inferior a 1 salário mínimo?</label>
                                        <div className="d-flex flex-row">
                                            <div className="form-check">
                                                <input onChange={() => handleChangeModalities('LB_EP', true)} type="radio" id="with_lace_0" name="LB_EP" value={1} ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao || !publicSchool} />
                                                <label htmlFor="with_lace_0">Sim</label>
                                            </div>
                                            <div className="form-check">
                                                <input onChange={() => handleChangeModalities('LB_EP', false)} defaultChecked type="radio" id="with_lace_1" name="LB_EP" value={0} ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao || !publicSchool} />
                                                <label htmlFor="with_lace_1">Não</label>
                                            </div>
                                            {montaMsgErroObrigatorio('LB_EP', 'Pessoa com renda PER CAPTA menor ou igual a 1 salário mínimo')}
                                        </div>
                                        {modalidades.includes('LB_EP') && montaMsgAtencao('Atenção', 'Será obrigatória a apresentação do Comprovante de Inscrição ou a Folha Resumo do CadÚnico do candidato, contendo as informações do grupo familiar atualizada nos últimos 12 meses e que possua o valor da renda per capita igual ou inferior a 1 salário mínimo.', true, 'declaracao_ciencia_LB_EP')}
                                    </section>}
                                <section className="form-radio required">
                                    <label>Deseja participar da modalidade de ingresso como pessoa com deficiência?</label>
                                    <div className="d-flex flex-row">
                                        <div className="form-check">
                                            <input onChange={() => handleChangeModalities('_PCD', true)} type="radio" id="disabled_person_0" name="_PCD" value={1} ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao} />
                                            <label htmlFor="disabled_person_0">Sim</label>
                                        </div>
                                        <div className="form-check">
                                            <input onChange={() => handleChangeModalities('_PCD', false)} defaultChecked type="radio" id="disabled_person_1" name="_PCD" value={0} ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao} />
                                            <label htmlFor="disabled_person_1">Não</label>
                                        </div>
                                        {montaMsgErroObrigatorio('_PCD', 'Pessoa com deficiência')}
                                    </div>
                                    {modalidades.includes('_PCD') && montaMsgAtencao('Atenção', 'Estou ciente de que os candidatos das modalidades reservadas às pessoas com deficiência deverão comprovar sua condição por meio do envio de Laudo Médico e Exames Comprobatórios da deficiência, conforme as exigências do edital.', true, 'declaracao_ciencia_PCD')}
                                </section>

                                {publicSchool &&
                                    (<>
                                        <section className="form-radio required">
                                            <label>Deseja participar da modalidade de ingresso como autodeclarado preto, pardo ou indígena?</label>
                                            <div className="d-flex flex-row">
                                                <div className="form-check">
                                                    <input onChange={() => handleChangeModalities('_PPI', true)} type="radio" id="black_brown_indigenous_person_0" name="_PPI" value={1} ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao || !publicSchool} />
                                                    <label htmlFor="black_brown_indigenous_person_0">Sim</label>
                                                </div>
                                                <div className="form-check">
                                                    <input onChange={() => handleChangeModalities('_PPI', false)} defaultChecked type="radio" id="black_brown_indigenous_person_1" name="_PPI" value={0} ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao || !publicSchool} />
                                                    <label htmlFor="black_brown_indigenous_person_1">Não</label>
                                                </div>
                                                {montaMsgErroObrigatorio('_PPI', 'Pessoa autodeclarada preto, pardo ou indígena')}
                                            </div>
                                            {modalidades.includes('_PPI') && montaMsgAtencao('Observação', "Entende-se, por fenótipo negróide (incluindo pretos e pardos), conforme Instrução Normativa GAB/FURG N° 4/2023, o conjunto de características físicas do indivíduo, predominantemente, a cor da pele, a textura do cabelo e os aspectos faciais que, combinados ou não, permitirá a realização da análise da veracidade da autodeclaração. As cotas PPI de que tratam a LEI nº 12.711/2012, são reservadas para os candidatos com características negróides, excluídas as considerações sobre a ascendência. \n\n As vagas dessas modalidades exigem que o candidato seja submetido a comissão de heteroidentificação para comprovação da sua autodeclaração etnico-racial.", true, 'declaracao_ciencia_PPI')}
                                        </section>

                                        <section className="form-radio required">
                                            <label>Deseja participar da modalidade de ingresso como autodeclarado quilombola?</label>
                                            <div className="d-flex flex-row">
                                                <div className="form-check">
                                                    <input onChange={() => handleChangeModalities('_Q', true)} type="radio" id="quilombola_person_0" name="_Q" value={1} ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao || !publicSchool} />
                                                    <label htmlFor="quilombola_person_0">Sim</label>
                                                </div>
                                                <div className="form-check">
                                                    <input onChange={() => handleChangeModalities('_Q', false)} defaultChecked type="radio" id="quilombola_person_1" name="_Q" value={0} ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao || !publicSchool} />
                                                    <label htmlFor="quilombola_person_1">Não</label>
                                                </div>
                                                {montaMsgErroObrigatorio('_Q', 'Pessoa autodeclarada Quilombola')}
                                            </div>
                                            {modalidades.includes('_Q') && montaMsgAtencao('Atenção', 'Será necessário comprovação da condição de candidato quilombola conforme as exigências do Edital do processo seletivo.', true, 'declaracao_ciencia_Q')}
                                        </section>
                                    </>
                                    )}


                                {modalidades &&
                                    <section>
                                        <hr className="hr" />
                                        <label>Modalidade{modalidades.length > 1 ? 's' : ''} em que você pode Concorrer.</label>
                                        <ul className="list-group-custom">
                                            {modalidades.includes('AC') && montaComponenteModalidades('Ampla concorrência', 'AC')}
                                            {modalidades.includes('_PCD') && montaComponenteModalidades('V - PROAAF (candidatos com deficiência, sem comprovação de escola pública e sem comprovação de renda)', 'V-PROAAF')}
                                            {modalidades.includes('LB_EP') && <h3 className="mt-4 text-secondary text-sd">Lei de cotas - Escola Pública, Renda Inferior</h3>}
                                            {modalidades.includes('LB_EP') && montaComponenteModalidades('LB_EP (Escola Pública, Renda Inferior)', 'LB_EP')}
                                            {modalidades.includes('LB_EP') && modalidades.includes('_PPI') && montaComponenteModalidades('LB_PPI (Escola Pública, Renda Inferior, Preto, Pardo ou Indígena)', 'LB_PPI')}
                                            {modalidades.includes('LB_EP') && modalidades.includes('_PCD') && montaComponenteModalidades('LB_PCD (Escola Pública, Renda Inferior, Pessoa com Deficiência)', 'LB_PCD')}
                                            {modalidades.includes('LB_EP') && modalidades.includes('_Q') && montaComponenteModalidades('LB_Q (Escola Pública, Renda Inferior, Declarado(a) quilombola)', 'LB_Q')}
                                            {modalidades.includes('LI_EP') && <h3 className="mt-4 text-secondary text-sd">Lei de cotas - Escola Pública, Renda Não Considerada</h3>}
                                            {modalidades.includes('LI_EP') && montaComponenteModalidades('LI_EP (Escola Pública, Renda Não Considerada)', 'LI_EP')}
                                            {modalidades.includes('LI_EP') && modalidades.includes('_PPI') && montaComponenteModalidades('LI_PPI (Escola Pública, Renda Não Considerada, Preto, Pardo ou Indígena)', 'LI_PPI')}
                                            {modalidades.includes('LI_EP') && modalidades.includes('_PCD') && montaComponenteModalidades('LI_PCD (Escola Pública, Renda Não Considerada, Pessoa com Deficiência)', 'LI_PCD')}
                                            {modalidades.includes('LI_EP') && modalidades.includes('_Q') && montaComponenteModalidades('LI_Q (Escola Pública, Renda Não Considerada, Declarado(a) quilombola)', 'LI_Q')}
                                        </ul>
                                    </section>
                                }
                            </fieldset>
                        </div>

                        <div className="card card-body w-100">

                            <fieldset>
                                <legend>Processo Seletivo</legend>
                                <hr className="hr" />
                                <div className="form-label-group required">
                                    <label htmlFor="enem">Digite o seu número de inscrição do ENEM</label>
                                    <input
                                        type="number"
                                        id="enem"
                                        name="enem"
                                        className="form-control"
                                        onBlur={(e) => handleVerifyEnemNumber(e.target.value)}
                                        ref={register({ required: 'Preenchimento obrigatório', minLength: { value: 12, message: 'Mínimo 12 dígitos' } })}
                                        disabled={!!nrInscricao}
                                    />
                                    {enemInfo && (
                                        <small className="form-text text-muted">
                                            <strong>Atenção:</strong> {enemInfo}
                                        </small>
                                    )}

                                    {enemInscriptionError &&
                                        <div className="invalid-feedback d-block font-weight-bold">
                                            Número de inscrição inválido
                                        </div>}
                                    {montaMsgErroObrigatorio('enem', 'Digite o seu número de inscrição do ENEM')}
                                </div>
                                <div className="form-label-group form-select required">
                                    <label htmlFor="curso">Curso</label>
                                    <select
                                        size="1"
                                        id="curso"
                                        name="curso"
                                        className="form-control"
                                        ref={register({ required: 'Preenchimento obrigatório' })}
                                        disabled={!!nrInscricao}
                                    >
                                        <option value="">Selecione um curso</option>
                                        {cursos.map(curso => (
                                            <option key={`curso_${curso.cd_curso}`} value={curso.cd_curso}>
                                                {curso.nm_curso}
                                            </option>
                                        ))}
                                    </select>
                                    {montaMsgErroObrigatorio('curso', 'Curso')}
                                </div>

                                <section className="form-checkbox required">
                                    <label>Requerimento de inscrição</label>
                                    <div className="form-check ml-0">
                                        <input type="checkbox" id="requerimento" name="requerimento" value="1" ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao} />
                                        <label htmlFor="requerimento" className='pb-0'>
                                            Venho requerer minha inscrição no Processo Seletivo da Universidade Federal do Rio Grande, responsabilizando-me por todas as declarações desta Ficha de
                                            Inscrição e afirmando que preencho as condições legais para a participação no processo.
                                            {montaMsgErroObrigatorio('requerimento', 'Requerimento de inscrição')}
                                        </label>

                                    </div>
                                    <div className="form-check ml-0 mt-2">
                                        <input type="checkbox" id="declaracao" name="declaracao" value="1" ref={register({ required: 'Preenchimento obrigatório' })} disabled={!!nrInscricao} />
                                        <label htmlFor="declaracao" className='pb-0'>
                                            Declaro, neste ato, que tenho pleno conhecimento do Edital do Processo Seletivo (disponível em coperse.furg.br), comprometendo-me a cumprir todas as disposições
                                            ali expressas, bem como a respeitar as decisões que venham a ser tomadas nos casos não previstos.
                                            {montaMsgErroObrigatorio('declaracao', 'Declaração de inscrição')}
                                        </label>
                                    </div>
                                </section>
                            </fieldset>
                        </div>

                        {!nrInscricao && !enemInscriptionError && (
                            <button type="submit" className="btn btn-primary btn-lg btn-block">
                                Realizar inscrição
                            </button>
                        )}
                    </form>
                )}
            </div>
        </div>
    )
}